import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa"; // Added icons
import "./Footer.css";

// Shape Imports
import shape1 from "../../assets/Shapes/shapes (1).png";
import shape2 from "../../assets/Shapes/shapes (2).png";
import shape3 from "../../assets/Shapes/shapes (3).png";
import shape4 from "../../assets/Shapes/shapes (4).png";
import shape5 from "../../assets/Shapes/shapes (5).png";
import shape6 from "../../assets/Shapes/shapes (6).png";

const Footer = ({ onContactClick }) => {
  const handleContactTrigger = (e) => {
    e.preventDefault();
    if (onContactClick) onContactClick();
  };

  const shapes = [
    { img: shape1, delay: 0.1, className: "s1" },
    { img: shape2, delay: 0.3, className: "s2" },
    { img: shape3, delay: 0.2, className: "s3" },
    { img: shape4, delay: 0.5, className: "s4" },
    { img: shape5, delay: 0.4, className: "s5" },
    { img: shape6, delay: 0.6, className: "s6" },
  ];

  return (
    <footer className="ascent-footer">
      <Container className="footer-main-content">
        <Row className="footer-top-row align-items-center mb-5">
          <Col md={8}>
            <h2  className="text-5xl md:text-7xl font-bold mb-3 text-[#001233] leading-[0.85]">Let's Ascent <br /> Together</h2>
          </Col>
          <Col md={4} className="text-md-end text-start">
            <Button className="get-in-touch-pill" onClick={handleContactTrigger}>
              Get in Touch
            </Button>
          </Col>
        </Row>

        <Row className="footer-links-row">
          <Col lg={3} md={4} xs={6} className="mb-4">
          
            <ul className="footer-list">
              <li>Branding</li>
              <li>Website Development</li>
               <li>Corporate Gifts</li>
            </ul>
          </Col>
          <Col lg={3} md={4} xs={6} className="mb-4">
            <ul className="footer-list">
              <li>Digital Marketing</li>
              <li>Photo & Video Production</li>
               <li>Print & Signage Solutions</li>
            </ul>
          </Col>
          {/* <Col lg={3} md={4} xs={12} className="mb-4">
            <h5 className="footer-label">Services</h5>
            <ul className="footer-list">
              <li>Corporate Gifts</li>
              <li>Print & Signage Solutions</li>
            </ul>
          </Col> */}
        </Row>
      </Container>

      <div className="footer-bottom-section">
        {/* FALLING SHAPES CONTAINER - Positioned relative to the line */}
        <div className="shapes-stack-container">
          {shapes.map((shape, index) => (
            <motion.img
              key={index}
              src={shape.img}
              className={`falling-shape ${shape.className}`}
              initial={{ y: -300, opacity: 0, rotate: -20 }}
              whileInView={{ y: 0, opacity: 1, rotate: 0 }}
              viewport={{ once: true }}
              transition={{ 
                type: "spring", 
                stiffness: 50, 
                damping: 10, 
                delay: shape.delay 
              }}
            />
          ))}
        </div>

        <div className="brand-color-strip">
          <div className="seg s-purple"></div>
          <div className="seg s-teal"></div>
          <div className="seg s-orange"></div>
          <div className="seg s-yellow"></div>
          <div className="seg s-pink"></div>
          <div className="seg s-blue"></div>
        </div>

        <Container style={{backgroundColor:"#0D1F46"}}>
          <div className="meta-flex" >
            <span className="footer-copyright">Ascent Brandworks © 2026</span>
            <div className="footer-right-group">
              <span className="footer-address">INDIA &nbsp;|&nbsp; MALASIYA</span>
              <div className="social-icons-box">
                <a href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
                <a href="https://linkedin.com" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;